var map = {
	"./DressingRoomDeathKnight.png": 3252,
	"./DressingRoomDruid.png": 4317,
	"./DressingRoomHunter.png": 6075,
	"./DressingRoomMage.png": 1583,
	"./DressingRoomPaladin.png": 8112,
	"./DressingRoomPriest.png": 632,
	"./DressingRoomRogue.png": 1671,
	"./DressingRoomShaman.png": 6119,
	"./DressingRoomWarlock.png": 6422,
	"./DressingRoomWarrior.png": 2911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4419;